import React from 'react'
import ReactDOM from 'react-dom'
import 'teaful-devtools'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'
import { isProd } from './consts'

Sentry.init({
  dsn: 'https://9a1dc0690533470183930092c5af26ad@sentry.io/3625993',
})

const cssFile = document.createElement('link')
cssFile.rel = 'stylesheet'
cssFile.href = isProd()
  ? 'https://cdn.vinissimus.com/front/static/icon-font/icons.css'
  : 'https://stage-cdn.vinissimus.com/front/static/icon-font/icons.css'

document.head.appendChild(cssFile)

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
